import { Component, OnInit } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-invalid-form-popup',
  templateUrl: './invalid-form-popup.component.html',
  styleUrls: ['./invalid-form-popup.component.scss']
})
export class InvalidFormPopupComponent implements OnInit {
  subject: Subject<boolean>;
  subscription: any;

  constructor(
    public bsModalRef: BsModalRef,
    private modalService: BsModalService,
  ) {}

  ngOnInit(): void {
    // Fix for when user clicks `ESC` instead of clicking, no Event was firing
    this.subscription = this.modalService.onHide.subscribe((reason: string) => {
      if(reason === 'esc')
        this.onCancel();
    })
  }

  ngOnDestroy(): void {
    if(this.subscription)
      this.subscription.unsubscribe();
  }

  onCancel(): void {
    this.bsModalRef.hide();
    this.subject.next(false);
    this.subject.complete();
  }

}
